import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/layouts/DashboardLayout";
import Login from "@/pages/Login";
import PublicOrder from "@/pages/PublicOrder";
import Overview from "@/pages/Overview";
import OrderStatus from "@/pages/OrderStatus";
import OrderTaking from "@/pages/OrderTaking";
import AcceptOnline from "@/pages/AcceptOnline";
import Kitchen from "@/pages/Kitchen";
import Delivery from "@/pages/Delivery";
import Takeaway from "@/pages/Takeaway";
import Inventory from "@/pages/Inventory";
import Reports from "@/pages/Reports";
import UserAccess from "@/pages/UserAccess";
import ShopSetup from "@/pages/ShopSetup";
import Settings from "@/pages/Settings";
import Tenants from "@/pages/Tenants";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/order" element={<PublicOrder />} />

            <Route path="/tenants" element={<ProtectedRoute roles={["superadmin"]}><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Tenants />} />
            </Route>

            <Route path="/" element={<ProtectedRoute roles={["admin", "shop_admin", "staff"]}><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Overview />} />
              <Route path="orders/status" element={<ProtectedRoute permission="order_status"><OrderStatus /></ProtectedRoute>} />
              <Route path="orders/new" element={<ProtectedRoute permission="order_taking"><OrderTaking /></ProtectedRoute>} />
              <Route path="orders/accept" element={<ProtectedRoute permission="accept_online"><AcceptOnline /></ProtectedRoute>} />
              <Route path="kitchen" element={<ProtectedRoute permission="kitchen"><Kitchen /></ProtectedRoute>} />
              <Route path="delivery" element={<ProtectedRoute permission="delivery"><Delivery /></ProtectedRoute>} />
              <Route path="takeaway" element={<ProtectedRoute permission="takeaway"><Takeaway /></ProtectedRoute>} />
              <Route path="inventory" element={<ProtectedRoute permission="inventory"><Inventory /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute permission="reports"><Reports /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute permission="users"><UserAccess /></ProtectedRoute>} />
              <Route path="shop-setup" element={<ProtectedRoute permission="shop_setup"><ShopSetup /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute permission="settings"><Settings /></ProtectedRoute>} />
            </Route>

            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
